import { Theme } from "@emotion/react";
import { Box, styled } from "@mui/material";

type FooterProps = {
  darkMode: boolean;
  theme?: Theme;
};

export const FooterWrapper = styled(
  Box,
  {},
)<FooterProps>(({ theme, darkMode }) => ({
  "&.footer-container": {
    zIndex: 100,
    position: "relative",
    borderBottom: !darkMode && "1px solid black",
    borderTop: !darkMode && "1px solid black",
    background: darkMode ? "black" : "white",
    color: darkMode ? "#888" : "black",
    left: 0,
    right: 0,
    height: "6rem",
    alignItems: "center",
    display: "flex",
    paddingLeft: "5%",
    paddingRight: "5%",
    ".footer": {
      width: "100%",
      maxWidth: "80rem",
      marginRight: "auto",
      marginLeft: "auto",
      [theme.breakpoints.up("xl")]: {
        maxWidth: "90rem",
      },
      ".footer-inner": {
        marginRight: "auto",
        marginLeft: "auto",
        justifyContent: "space-between",
        display: "flex",
        [theme.breakpoints.down("sm")]: {
          flexDirection: "column",
        },
        ".link": {
          cursor: "pointer",
          textDecoration: "underline",
          fontSize: ".75rem",
        },
        ".copy-right": {
          fontSize: ".75rem",
        },
      },
    },
  },
}));
